<template>
  <div class="mm-page-main" v-loading="loading">
    <div class="page-header">
      <div class="page-title">編輯門市</div>
      <div @click="pageback" class="page-back">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-back"></use>
        </svg>
      </div>
    </div>
    <div class="pagemain">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="left">
        <div class="form-group">
          <div class="form-group-content">
            <div class="mm-row-block">
              <div class="form-isheader-group">
                <div class="group-title">
                  <h3>部門門市</h3>
                </div>
                <el-input type="hidden" v-model="form.id"></el-input>
                <div class="form-isheader-group-content">
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="部門名稱" prop="name">
                        <el-input v-model="form.name"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="門市簡稱" prop="short">
                        <el-input v-model="form.short"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="所屬MSO" prop="mso_id">
                        <el-select class="elselect" v-model="form.mso_id" placeholder="请选择">
                          <el-option v-for="(mso) in msos" :key="mso.id" :label="mso.name" :value="mso.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <!-- <div class="mm-col" style="flex: 0 100px; margin-left: 10px;">
                      <el-button @click="addmso" type="primary" class="text-white">添加MSO</el-button>
                    </div> -->

                  </div>
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="門市地址" prop="address">
                        <el-input v-model="form.address"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="門市電話" prop="phone">
                        <el-input v-model="form.phone"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="門市傳真" prop="fax">
                        <el-input v-model="form.fax"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="門市電郵" prop="email">
                        <el-input v-model="form.email"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="Whatsapp" prop="whatsapp">
                        <el-input v-model="form.whatsapp"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row">
                    <el-form-item label="狀態">
                      <el-switch v-model="form.status" active-text="啟用" inactive-text="禁用">
                      </el-switch>
                    </el-form-item>

                  </div>

                  <div class="mm-row">
                    <el-form-item label="匯款記帳">
                      <el-switch v-model="form.bookkeeping" active-text="啟用" inactive-text="禁用">
                      </el-switch>
                      <span style="margin-left:20px">*啟用后，門市匯款模塊可以進行人工記帳*</span>
                    </el-form-item>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="form-submit">
          <el-button @click="formsubmit('form')" type="primary">提交</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {

  data () {
    return {
      loading: false,
      msos: [],
      form: {
        status: true,
        mso_id: ''
      },
      rules: {

        name: [{
          required: true,
          message: '請填寫門市名稱',
        }],
        short: [{
          required: true,
          message: '請填寫門市简称'
        }],
        mso_id: [{
          required: true,
          message: '請選擇所屬MSO',
          trigger: 'change'
        }],


      }
    };
  },
  methods: {
    addmso () {
      this.$router.push('/AddMSO');
    },
    pageback () {
      this.$router.go(-1);
    },
    geteditdata () {
      let id = this.$route.params.id;

      if (id) {
        this.loading = true;
        this.post('/api/store/edit', {
          id: id
        }).then((res) => {
          if (res) {
            if (res.status == 0) {
              res.status = true;
            } else {
              res.status = false;
            }

            if (res.bookkeeping == 0) {
              res.bookkeeping = false;
            } else {
              res.bookkeeping = true;
            }
            this.form = res;
          }

          this.loading = false;
        }).catch((err) => {
          this.loading = false;
          console.log(err)
        });
      }
    },
    formsubmit (form) {

      this.$refs[form].validate((valid) => {
        if (valid) {
          this.loading = true;
          let data = this.form;
          this.post('/api/store/editsave', {
            data: data
          }).then((res) => {
            this.loading = false;

            if (res == 'success') {
              this.$message({
                showClose: true,
                message: '編輯門市成功！',
                type: 'success',
                onClose: (() => {
                })
              });
              this.pageback();
            } else {
              this.$message({
                showClose: true,
                message: '編輯門市失敗，請重試！',
                type: 'error',

              });
            }


          }).catch((err) => {
            this.loading = false;
            console.log(err)
          });
        }
      });
    },
    getmso () {
      this.loading = true;
      this.post('/api/mso/index', {}).then((res) => {
        this.msos = res;
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        console.log(err)
      });
    }
  },
  created () {
    this.geteditdata();
    this.getmso();
  }

};
</script>
<style scoped>
.mm-row {
  width: 50%;
}
@media screen and (max-width: 1024px) {
  .mm-row {
    width: 100%;
    display: block;
  }
}
</style>
